import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import style from './style';
import './index.css';

const propTypes = {
  items: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  muiOptions: PropTypes.object,
  placeholder: PropTypes.string,
  errorMsg: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  muiOptions: {},
  placeholder: null,
  errorMsg: null,
};

const renderItems = items => {
  const intoMenuItems = (item, i) => {
    return <MenuItem {...item} key={item.key || item.value || i} />;
  };

  return items.map(intoMenuItems);
};

const Dropdown = ({ items, value, onChange, placeholder, errorMsg, muiOptions }) => {
  return (
    <div className="Dropdown">
      <div className="Dropdown__mui_component_wrapper">
        <SelectField
          className="Dropdown__mui_component"
          {...muiOptions}
          {...style}
          hintText={placeholder}
          value={value}
          onChange={onChange}
          errorText={errorMsg}
        >
          {renderItems(items)}
        </SelectField>
      </div>
    </div>
  );
};

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;

export default Dropdown;



// WEBPACK FOOTER //
// ../ui-components/components/Dropdown/index.jsx